/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum FilterGroupingOperation {
    ExclusiveOr = 'exclusiveOr',
    Or = 'or',
    And = 'and',
    Not = 'not',
}
